import {ActionList, ActionMenu, RelativeTime, Button} from '@primer/react'
import {SinceSource} from '../../../routes/route-payload-types'
import {useEffectiveSelection} from '../data/use-effective-selection'
import {useRef} from 'react'
import {DockedPanel, useDockedPanelActions} from '../../../contexts/DockedPanelContext'
import {FilterIcon} from '@primer/octicons-react'

const sinceSourceDescriptionMap: Record<SinceSource, string> = {
  [SinceSource.Created]: 'Since this pull request was created',
  [SinceSource.LastReview]: 'Since your last review',
  [SinceSource.LastInteracted]: 'Since you last interacted',
  [SinceSource.ReadyForReview]: 'Since marked ready for review',
}

/** Selector dropdown for the Activity section — rendered in the CollapsiblePanel header */
export function ActivitySelector() {
  const {sinceSelectors, effectiveSelection, handleSelect} = useEffectiveSelection()
  const {openPanel} = useDockedPanelActions()
  const timelineButtonRef = useRef<HTMLButtonElement>(null)

  if (!effectiveSelection || sinceSelectors.length === 0) return null

  return (
    <span className="d-flex flex-row gap-2 align-items-center">
      <Button
        ref={timelineButtonRef}
        size="small"
        variant="invisible"
        onClick={() => openPanel(DockedPanel.Timeline, {returnFocusTo: timelineButtonRef.current})}
      >
        Full Timeline
      </Button>
      <ActionMenu>
        <ActionMenu.Anchor>
          <Button leadingVisual={FilterIcon} size="small" variant="invisible">
            {sinceSourceDescriptionMap[effectiveSelection?.source ?? '']}
          </Button>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay align="end">
          <ActionList selectionVariant="single">
            {sinceSelectors.map(selector => (
              <ActionList.Item
                key={selector.source}
                selected={selector.source === effectiveSelection?.source}
                onSelect={() => handleSelect(selector)}
              >
                {sinceSourceDescriptionMap[selector.source]}
                <ActionList.Description>
                  <RelativeTime date={new Date(selector.timestamp)} />
                </ActionList.Description>
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </span>
  )
}
